import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.004",
  cy: "6.54",
  r: "3.783",
  stroke: "currentColor",
  "stroke-width": "1.385"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.385",
  d: "M20.825 20.933a8.821 8.821 0 0 0-17.642 0M18.061 6.07h3.019M19.57 4.56V7.58M3.08 10.323h2.47M4.315 9.089v2.469"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.385",
  d: "M11.774 14.339a.277.277 0 0 1 .469 0l.979 1.554c.038.06.097.104.166.121l1.78.451c.199.05.276.29.146.446l-1.176 1.412a.277.277 0 0 0-.063.195l.121 1.833a.277.277 0 0 1-.38.276l-1.705-.682a.277.277 0 0 0-.206 0l-1.705.682a.277.277 0 0 1-.38-.276l.122-1.833a.277.277 0 0 0-.064-.195L8.702 16.91a.277.277 0 0 1 .145-.446l1.781-.45a.277.277 0 0 0 .167-.122l.979-1.554Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }